// @flow
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import ReactHtmlParser from 'react-html-parser';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { camelizeKeys } from 'humps';
import { Button } from 'semantic-ui-react';
import Link from '../Link';
import ResourceTile from '../ResourceTile';
import { createExcerptIfNotDefined, noCamelize } from '../../helpers';
import type {
  FeaturedResources as FeaturedResourcesType,
  FeaturedResource as FeaturedResourceType,
} from '../../types';
import { API_BASE } from '../../helpers';

type Props = {
  row: FeaturedResourcesType,
};

type State = {
  featuredResources: Array<FeaturedResourceType> | boolean,
};

class FeaturedResources extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      featuredResources: this.props.row.featuredResourcesRepeater,
    };
  }

  componentDidMount() {
    // Retrieve each featured resource's type via API, then store in local state.
    const { featuredResourcesRepeater } = this.props.row;
    if (typeof featuredResourcesRepeater !== 'boolean') {
      featuredResourcesRepeater.forEach(async (featuredResource, i) => {
        const { resource } = featuredResource;

        try {
          const response = await fetch(
            `${API_BASE}/wp-json/acf/v3/posts/${resource.id}/resource_format`
          );
          const json = await response.json();

          const camelizedJson = camelizeKeys(json, noCamelize);
          const workingArray = this.state.featuredResources;
          if (
            typeof workingArray !== 'boolean' &&
            typeof workingArray[i].resource !== 'boolean'
          ) {
            workingArray[i].resource.acf = {
              resourceFormat: camelizedJson.resourceFormat,
            };
          }

          this.setState({
            featuredResources: workingArray,
          });
        } catch (error) {
          Sentry.captureException(error);
          // eslint-disable-next-line no-console
          console.error('An error occured.', error);
        }
      });
    }
  }

  render(): React.Element<"div"> {
    const { row } = this.props;

    return (
      <div className="page-row ">
        {typeof row.title === 'string' && row.title && (
          <h2
            className={`page-row__title text--${row.accentColour
              .toString()
              .toLowerCase()}`}
          >
            {ReactHtmlParser(row.title)}
          </h2>
        )}
        <Carousel
          className="testimonials__carousel"
          showThumbs={false}
          showArrows={true}
          showStatus={false}
          showIndicators={true}
          emulateTouch={true}
        >
          {typeof row.featuredResourcesRepeater !== 'boolean' &&
            row.featuredResourcesRepeater.map((resource, i) => {
              if (typeof resource.resource !== 'boolean') {
                return (
                  <ResourceTile
                    key={i}
                    resourceFormatSlug={
                      resource.resource.acf &&
                      resource.resource.acf.resourceFormat
                        ? resource.resource.acf.resourceFormat.slug
                        : undefined
                    }
                    title={resource.resource.postTitle}
                    excerpt={createExcerptIfNotDefined(
                      resource.resource.postExcerpt,
                      resource.resource.postContent
                    )}
                    slug={resource.resource.postName}
                    className="owl-item-inner--max-width"
                    smallTitle={row.title ? true : false}
                  />
                );
              }
              return null;
            })}
        </Carousel>
        {typeof row.link === 'string' && row.link && (
          <div className="page-row__buttons">
            <Button as={Link} url={row.link} inverted>
              View all Resources
            </Button>
          </div>
        )}
        {typeof row.link === 'object' && row.link && (
          <div className="page-row__buttons">
            {/* $FlowFixMe */}
            <Button as={Link} url={row.link.url} inverted>
              {ReactHtmlParser(row.link.title)}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default FeaturedResources;
